<template>
  <!--<img alt="Vue logo" src="./assets/logo.png">
  <HelloWorld msg="Welcome to Your Vue.js App"/>
  <HeaderTop :authed="authOrNot" />-->
  <header class="text-gray-600 body-font dark:text-gray-300 dark:bg-slate-800">
    <div class="container mx-auto flex flex-wrap p-5 flex-col md:flex-row pt-16 items-center">
      <a class="flex title-font font-medium items-center mb-4 md:mb-0 cursor-pointer" @click="goHome">
        <!--
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-10 h-10 text-white p-2 bg-green-500 rounded-full" viewBox="0 0 24 24">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
        </svg>-->
        <img src="./assets/logo.svg" alt="Onlyfax logo" class="w-20 h-20">
        <span class="ml-3 xs:text-xl dark:text-gray-100">Only Facts Here👍</span>
      </a>
      <nav v-if="!authOrNot" class="md:ml-auto flex flex-wrap items-center text-base justify-center">
        <router-link to="/login"><a class="mr-5 hover:text-gray-900 dark:hover:text-gray-50">Log In </a></router-link>
        <router-link to="/create-account"><a class="mr-5 hover:text-gray-900 dark:hover:text-gray-50">Create Account</a></router-link>
        <!--<a class="mr-5 hover:text-gray-900">Third Link</a>
        <a class="mr-5 hover:text-gray-900">Fourth Link</a>-->
      </nav>
      <nav v-else class="md:ml-auto flex flex-wrap items-center text-base justify-center">
        <!--
        <a class="mr-5 hover:text-gray-900 cursor-pointer dark:hover:text-gray-50 flex flex-col" @click="goToFeed">Feed <div v-if="$router.currentRoute.includes('feed')" class="mt-0">-</div></a>
        <a class="mr-5 hover:text-gray-900 cursor-pointer dark:hover:text-gray-50 flex flex-col" @click="goToPosts">Dashboard<div v-if="$router.currentRoute.includes('posts')" class="mt-0">-</div></a>
        <a class="mr-5 hover:text-gray-900 cursor-pointer dark:hover:text-gray-50 flex flex-col" @click="createPost">Add Post<div v-if="$router.currentRoute.includes('create-post')" class="mt-0">-</div></a>
        -->
        <a class="mr-5 hover:text-gray-900 cursor-pointer dark:hover:text-gray-50 flex flex-col text-xs sm:text-sm md:text-lg" @click="goToFeed">Feed</a>
        <a class="mr-5 hover:text-gray-900 cursor-pointer dark:hover:text-gray-50 flex flex-col text-xs sm:text-sm md:text-lg" @click="goToPosts">Dashboard</a>
        <a class="mr-5 hover:text-gray-900 cursor-pointer dark:hover:text-gray-50 flex flex-col text-xs sm:text-sm md:text-lg" @click="createPost">Add Post</a>
        <a class="mr-5 hover:text-gray-900 cursor-pointer dark:hover:text-gray-50 flex sm:hidden text-xs sm:text-sm flex-col md:text-lg" @click="logMeOut">Logout</a>
        <!--<a class="mr-5 hover:text-gray-900">Third Link</a>
        <a class="mr-5 hover:text-gray-900">Fourth Link</a>-->
        <button @click="logMeOut" class="sm:inline-flex hidden items-center bg-gray-100 dark:bg-opacity-0 dark:border dark:border-solid dark:border-gray-100 dark:hover:text-gray-600 border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-4 md:mt-0">Log Out
          <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-1" viewBox="0 0 24 24">
            <path d="M5 12h14M12 5l7 7-7 7"></path>
          </svg>
        </button>
      </nav>
    </div>
  </header>
  <div class=" dark:text-slate-200 dark:bg-slate-800 h-full">
  <router-view @passJWTToParent="(recjwt) => {myjwt = recjwt; authOrNot = true; storeToLocal(recjwt)}"  />
  </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
//import HeaderTop from './components/HeaderTop.vue'
const devServer = process.env.VUE_APP_PROD_SERVER || "http://localhost:3030" ;

export default {
  name: 'App',
  components: {
    //HeaderTop,
  },
  data() {
    return {
      authOrNot: false,
      myjwt: {
        token: "",
        username: ""
      },
    }
  },

  created() {
    //this.snacc(JSON.stringify(localStorage.getItem('token')));
    this.checkAuth();
    /*
    [
      {
        "id": 4389,
        "text": "Hello",
        "author": "cyto"
      },

      {
        "id": 4390,
        "text": "domst",
        "author": "cyto"
      }
    ]
    */
  },

  methods: {

    goHome: async function() {
      this.$router.push('/')
    },

    storeToLocal: async function (myjwt) {
      if(myjwt.rememberme) {
        localStorage.setItem("token", myjwt.token);
        localStorage.setItem("username", myjwt.username);
      }
    },

    getFromLocal: async function () {
      this.myjwt.token = localStorage.getItem("token");
      this.myjwt.username = localStorage.getItem("username");
      this.checkAuth(true);
    },

    checkAuth: async function(dontCheckLocalCreds = false) {
      let respomse = await fetch(`${devServer}/api/auth/checkAuth/`, {headers: {"Content-Type": "application/json", "authorization": `Bearer ${this.myjwt.token}`, mode: "cors"}});
      let res = await respomse.json();
      this.myjwt.username = res.username;
      //console.log(this.myjwt);
      this.authOrNot = await res.isAuthed;

      // the program decides if not in local and then stops trying
      if(!this.authOrNot && !dontCheckLocalCreds) {
        // to try from local
        this.getFromLocal();
      }
    },
    
    goToPosts: async function() {
      this.$router.push({path: `/posts/${this.myjwt.token}`})
    },

    goToFeed: async function() {
      this.$router.push({path: `/feed/${this.myjwt.token}`})
    },

    logMeOut: async function () {
      this.myjwt.token = "";
      this.myjwt.username = "";
      localStorage.setItem("token", "");
      localStorage.setItem("username", "");
      this.authOrNot = false;
      this.$router.push('/login');
    },

    createPost: async function() {
      this.$router.push(`/create-post/${this.myjwt.token}`)
    }

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
